import { Row } from '@tanstack/react-table';
import Button from 'components/button/Button';
import useOpenLeadModal from 'components/domain/lead/modal/useOpenLeadModal';
import { AirbnbGuestReview } from 'models/Reviews';

const GuestNameCell = ({ row }: { row: Row<AirbnbGuestReview> }) => {
  const { updateLeadModal } = useOpenLeadModal();

  const handleClickGuest = () => {
    const { leadUid } = row.original;
    if (leadUid) {
      updateLeadModal({ leadUid });
    }
  };

  return (
    <Button
      bsStyle="link"
      data-testid="row-guest-name-lead-button"
      onClick={handleClickGuest}
    >
      {row.original.guestName}
    </Button>
  );
};

export default GuestNameCell;
